import { z } from 'zod';

/**
 * Coerces null/undefined to empty string for Formik compatibility.
 * Formik initializes empty fields as undefined/null, but Zod expects strings.
 * Used by: auth, form, subform (all FE schemas that validate text input)
 */
export const str = (val) =>
  val == null ? '' : typeof val === 'string' ? val : String(val);

/**
 * Wraps a schema to convert '' and null to undefined before validation.
 * HTML forms send '' for empty optional inputs, which fails .optional()
 * because '' is a present string. This converts '' → undefined first.
 * Used by: form (description), subform (description)
 */
export const emptyToUndefined = (schema) =>
  z.preprocess((val) => (val === '' || val === null ? undefined : val), schema);

/**
 * Coerces various boolean representations to native boolean.
 * Accepts: true/false, 1/0, '1'/'0'. Defaults to false for null/undefined.
 * Used by: form (published, template), subform (template)
 */
export const booleanFlag = (errorMsg) =>
  z.preprocess(
    (val) => {
      if (val === undefined || val === null) return false;
      if (val === true || val === 1 || val === '1') return true;
      if (val === false || val === 0 || val === '0') return false;
      return val;
    },
    z.boolean({ error: errorMsg })
  );
